import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { a11y } from '~js/components/a11y';

const Flickity = themeVendor.Flickity

export class ShoppableBlog {
  constructor(section) {
    this.container = section.container;
    this.flkty = null;
    this.slider = this.container.querySelector(s.selectors$4.slider);
    this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
    this.isFullWidth = this.container.hasAttribute(a.attributes$3.fullWidth);
    this.gutter = 0;
    this.a11y = a11y;
    this.clickOutsideItemEvent = (e) => {
      const clickOutsideSliderItem = !(
        e.target.matches(s.selectors$4.sliderItem) || e.target.closest(s.selectors$4.sliderItem)
      );

      if (clickOutsideSliderItem) {
        const sliderItem = this.container.querySelectorAll(s.selectors$4.sliderItem);
        if (sliderItem.length) {
          sliderItem.forEach((item) => {
            const itemProducts = item.querySelector(s.selectors$4.itemProducts);
            if (itemProducts) {
              itemProducts.classList.remove(c.classes$4.itemProductsVisible);

              this.changeTabIndex(itemProducts);
            }
            item.classList.remove(c.classes$4.itemActive);
          });
        }
      }
    };

    this.bindButtons();
    this.listen();
  }

  initSlider() {
    this.flkty = new Flickity(this.slider, {
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
      wrapAround: false,
      groupCells: true,
      contain: true,
      on: {
        ready: () => {
          this.handleFocus();
        },
      },
    });

    this.flkty.on('change', () => {
      const slides = this.container.querySelectorAll(s.selectors$4.sliderItem);

      this.handleFocus();

      if (slides.length) {
        slides.forEach((el) => {
          const itemProducts = el.querySelector(s.selectors$4.itemProducts);

          el.classList.remove(c.classes$4.itemActive);

          if (itemProducts) {
            el.querySelector(s.selectors$4.itemProducts).classList.remove(c.classes$4.itemProductsVisible);
          }
        });
      }

      if (this.flkty && !this.flkty.options.draggable) {
        this.flkty.options.draggable = true;
        this.flkty.updateDraggable();
      }
    });
  }

  destroySlider() {
    if (this.flkty !== null) {
      this.flkty.destroy();
      this.flkty = null;
    }
  }

  checkSlidesSize() {
    const sliderItemStyle =
      this.container.querySelector(s.selectors$4.sliderItem).currentStyle ||
      window.getComputedStyle(this.container.querySelector(s.selectors$4.sliderItem));
    this.gutter = parseInt(sliderItemStyle.marginRight);
    const containerWidth = this.slider.offsetWidth + this.gutter;
    const itemsWidth = this.getItemsWidth();
    const itemsOverflowViewport = containerWidth < itemsWidth;

    if (window.innerWidth >= theme.sizes.small && itemsOverflowViewport) {
      this.initSlider();
    } else {
      this.destroySlider();
    }
  }

  getItemsWidth() {
    let itemsWidth = 0;
    const slides = this.slider.querySelectorAll(s.selectors$4.sliderItem);
    if (slides.length) {
      slides.forEach((item) => {
        itemsWidth += item.offsetWidth + this.gutter;
      });
    }

    return itemsWidth;
  }

  bindButtons() {
    const itemProductSlider = this.container.querySelectorAll(s.selectors$4.itemProductSlider);
    const buttonProductsShow = this.container.querySelectorAll(s.selectors$4.buttonProductsShow);
    const buttonProductsHide = this.container.querySelectorAll(s.selectors$4.buttonProductsHide);

    if (buttonProductsShow.length) {
      buttonProductsShow.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();

          this.container.querySelectorAll(s.selectors$4.sliderItem).forEach((item) => {
            const itemProducts = item.querySelector(s.selectors$4.itemProducts);
            item.classList.remove(c.classes$4.itemActive);

            if (itemProducts) {
              itemProducts.classList.remove(c.classes$4.itemProductsVisible);

              this.changeTabIndex(itemProducts);
            }
          });

          const item = button.closest(s.selectors$4.sliderItem);
          const itemProducts = item.querySelector(s.selectors$4.itemProducts);
          item.classList.add(c.classes$4.itemActive);

          if (itemProducts) {
            itemProducts.classList.add(c.classes$4.itemProductsVisible);
            this.changeTabIndex(itemProducts, 'enable');

            const itemProductsSlider = itemProducts.querySelector(s.selectors$4.itemProductSlider);
            const allSlides = itemProductsSlider.querySelectorAll(s.selectors$4.itemProduct);
            const sliderActive = itemProductsSlider.classList.contains(c.classes$4.flickityEnabled);

            if (sliderActive) {
              const currentSlide = itemProductsSlider.querySelector(`.${c.classes$4.isSelected}`);
              const currentSlideIndex = currentSlide.getAttribute(a.attributes$3.slidePosition);

              allSlides.forEach((slide, i) => {
                slide.setAttribute(a.attributes$3.tabIndex, i === currentSlideIndex ? '0' : '-1');
              });
            }
          }

          if (this.flkty !== null) {
            this.flkty.options.draggable = false;
            this.flkty.updateDraggable();
          }

          this.a11y.state.trigger = button;
        });
      });
    }

    if (buttonProductsHide.length) {
      buttonProductsHide.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const item = button.closest(s.selectors$4.sliderItem);
          const itemProducts = item.querySelector(s.selectors$4.itemProducts);
          item.classList.remove(c.classes$4.itemActive);

          if (itemProducts) {
            itemProducts.classList.remove(c.classes$4.itemProductsVisible);

            this.changeTabIndex(itemProducts);
          }

          if (this.flkty !== null) {
            this.flkty.options.draggable = true;
            this.flkty.updateDraggable();
          }

          this.a11y.state.trigger.focus();
        });
      });
    }

    if (itemProductSlider.length) {
      itemProductSlider.forEach((slider) => {
        const countSlides = slider.querySelectorAll(s.selectors$4.itemProduct).length;

        if (countSlides > 1) {
          const flktyProducts = new Flickity(slider, {
            prevNextButtons: true,
            contain: true,
            pageDots: false,
            wrapAround: true,
            on: {
              change: (index) => {
                flktyProducts.cells.forEach((slide, i) => {
                  slide.element.querySelectorAll(s.selectors$4.links).forEach((link) => {
                    link.setAttribute(a.attributes$3.tabIndex, i === index ? '0' : '-1');
                  });
                });
              },
            },
          });
        }
      });
    }

    this.slider.addEventListener('keyup', (event) => {
      if (event.code === theme.keyboardKeys.ESCAPE) {
        const sliderItem = event.target.hasAttribute(a.attributes$3.slider)
          ? event.target.querySelectorAll(s.selectors$4.sliderItem)
          : event.target.closest(s.selectors$4.slider).querySelectorAll(s.selectors$4.sliderItem);

        if (sliderItem.length) {
          sliderItem.forEach((item) => {
            const itemProducts = item.querySelector(s.selectors$4.itemProducts);
            item.classList.remove(c.classes$4.itemActive);
            if (itemProducts) {
              itemProducts.classList.remove(c.classes$4.itemProductsVisible);

              this.changeTabIndex(itemProducts);
            }
          });

          if (this.flkty) {
            this.flkty.options.draggable = true;
            this.flkty.updateDraggable();
          }
        }

        this.a11y.state.trigger.focus();
      }
    });
  }

  handleFocus() {
    const sliderItems = this.container.querySelectorAll(s.selectors$4.sliderItem);

    if (sliderItems.length) {
      sliderItems.forEach((item) => {
        const selected = item.classList.contains(c.classes$4.isSelected);
        const itemProducts = item.querySelector(s.selectors$4.itemProducts);

        if (!selected) {
          this.changeTabIndex(item);

          if (itemProducts) {
            itemProducts.classList.remove(c.classes$4.itemProductsVisible);
          }
        } else {
          this.changeTabIndex(item, 'enable');

          if (itemProducts) {
            this.changeTabIndex(itemProducts);
          }
        }
      });
    }
  }

  listen() {
    if (this.slider) {
      this.checkSlidesSize();
      document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
    }

    document.addEventListener('mousedown', this.clickOutsideItemEvent);
  }

  changeTabIndex(items, state = '') {
    const tabIndex = state === 'enable' ? '0' : '-1';
    items.querySelectorAll(s.selectors$4.links).forEach((link) => {
      link.setAttribute(a.attributes$3.tabIndex, tabIndex);
    });
  }

  onBlockSelect(evt) {
    if (this.flkty !== null) {
      const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
      const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
      const groupIndex = Math.floor(index / slidesPerPage);

      this.flkty.select(groupIndex);
    } else {
      const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
      const sliderPadding = parseInt(sliderStyle.paddingLeft);
      const blockPositionLeft = evt.target.offsetLeft - sliderPadding;

      // Native scroll to item
      this.slider.scrollTo({
        top: 0,
        left: blockPositionLeft,
        behavior: 'smooth',
      });
    }
  }

  onUnload() {
    document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
    document.removeEventListener('mousedown', this.clickOutsideItemEvent);
  }
}